import { Validator } from "@/classes/validators/Validator";

export class TextValidator extends Validator {
  validate(): boolean {
    return true;
  }
}
